import { useState, useEffect, createContext, useContext } from 'react';
import firebaseService from '../../services/firebaseService';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log('🔄 Setting up auth state listener...');
    
    const unsubscribe = firebaseService.onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
    });

    return () => {
      console.log('🛑 Cleaning up auth state listener');
      unsubscribe();
    };
  }, []);

  const login = async (email, password) => {
    try {
      await firebaseService.signIn(email, password);
    } catch (error) {
      throw error;
    }
  };

  const register = async (email, password) => {
    try {
      await firebaseService.createAccount(email, password);
    } catch (error) {
      throw error;
    }
  };

  const logout = async () => {
    try {
      await firebaseService.signOut();
    } catch (error) {
      throw error;
    }
  };

  const resetPassword = async (email) => {
    try {
      await firebaseService.sendPasswordReset(email);
    } catch (error) {
      throw error;
    }
  };

  const getToken = async (forceRefresh = false) => {
    try {
      return await firebaseService.getIdToken(forceRefresh);
    } catch (error) {
      throw error;
    }
  };

  const value = {
    user,
    loading,
    login,
    register,
    logout,
    resetPassword,
    getToken,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
